var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-section"},[_c('div',{staticClass:"section-title mb-4"},[_vm._v("Thông tin khách hàng")]),_c('CustomerInfo',{key:_vm.customerInfoKey,attrs:{"bill-data":_vm.billDataForCustomerInfo,"from-order":false,"action":"create","on-submiting":_vm.onSubmiting},on:{"onUpdate":_vm.onCustomerUpdate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }